import { jsx as _jsx } from "react/jsx-runtime";
import invariant from 'ts-invariant';
import { getWaysteContext } from './WaysteContext';
export const WaysteProvider = ({ client, children }) => {
    const WaysteContext = getWaysteContext();
    return (_jsx(WaysteContext.Consumer, { children: (context = {}) => {
            if (client && context.client !== client) {
                context = Object.assign({}, context, { client });
            }
            // if no client throw
            invariant(context.client, 'WaysteProvider was not passed a client instance. Make ' + 'sure you pass in your client via the "client" prop.');
            return _jsx(WaysteContext.Provider, { value: context, children: children });
        } }));
};
//# sourceMappingURL=WaysteProvider.js.map